import React, { useState, useRef, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { generateSalesMaterial } from '../../../../queries/booklet';
import { useNavigationContext } from '../../../../context/NavigationContext';
import { useDashboardTeamContext } from '../../../../context/DashboardTeamContext';
import { MediaType } from '../../utils/mediaGenerator';
import QrDownloader from './QrDownloader';
import SalesMaterialDownloader from './SalesMaterialDownloader';
import BookletsViewer from './BookletsViewer';
import { Button, PageHeader } from '../../../../common';
import ResourceSection from '../../ResourceSection';

const SalesMaterial: React.FC = () => {
  const { associationData, teamData, associationBooklets, shopShareDomain } = useDashboardTeamContext();
  const { setNavigationActivated } = useNavigationContext();

  const [generateSalesMaterialMutation] = useMutation(generateSalesMaterial);
  const [generatingMediaType, setGeneratingMediaType] = useState<MediaType | null>(null);
  const qrCodeUrl = `${shopShareDomain}/${teamData?.associationSlug}/${teamData?.slug}`;

  useEffect(() => {
    setNavigationActivated(true);
  }, [setNavigationActivated]);

  const handleDownload = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div id='dashboard' className='resources'>
      <PageHeader>
        <h1>Säljmaterial</h1>
        <p>Här finns en säljguide och annat material att använda för att nå ännu bättre försäljning. Ladda ned och dela ut till gruppen.</p>
      </PageHeader>
      <ResourceSection title='Säljguide'>
        <p>Få praktiska tips och råd för hur du och ni kan maximera er försäljning och nå era mål på bästa sätt.</p>
        <Button className='primary alt md' onClick={() => handleDownload('https://cityhaftet.se/resurser/Saljguide_vardebevis.pdf')}>
          <div className="flex gap-1 items-center justify-center">
            <span>Ladda ned säljguide</span>
          </div>
        </Button>
      </ResourceSection>
      {associationData && teamData && (
        <SalesMaterialDownloader
          association={associationData}
          associationBooklets={associationBooklets}
          team={teamData}
          generateSalesMaterialMutation={generateSalesMaterialMutation}
          generatingMediaType={generatingMediaType}
          setGeneratingMediaType={setGeneratingMediaType}
        />
      )}
      {teamData && (
        <QrDownloader
          name={teamData.name}
          qrCodeUrl={qrCodeUrl}
        />
      )}
      <BookletsViewer
        associationBooklets={associationBooklets}
      />
      <ResourceSection title='Beställningslista'>
        <p>Använd den här listan för att samla in beställningar.</p>
        <Button className='primary alt md' onClick={() => handleDownload('https://cityhaftet.se/resurser/Bestallningslista.pdf')}>
          <div className="flex gap-1 items-center justify-center">
            <span>Ladda ned beställningslista</span>
          </div>
        </Button>
      </ResourceSection>
    </div>
  );
};

export default SalesMaterial;
